import { LeadsInfoClientRequest } from '../../../@types/LeadsInfo'
import { useRunPetisSimulationStore } from '../../../Stores/useRunPetisSimulationStore'
import { useSimulatorStore } from '../../../Stores/simulatorStore'
import { LEADS_INFO } from '../../../constants/leadsInfo'


export const useLeadsInfoPayload = () => {
  const { runPetisSimulation } = useRunPetisSimulationStore()
  const { NPALeadsContext } = useSimulatorStore()

  const leadsInfoPayload: LeadsInfoClientRequest = {
    simulationExternalId: runPetisSimulation?.runPetisSimulationResponse?.quoteId || "",
    leadId: NPALeadsContext?.leadId || "",
    lob: LEADS_INFO.lob
  }

  return leadsInfoPayload
}
